module.exports = __webpack_public_path__ + "static/media/Language courses in Delhi University.f26de753.jpg";